import { render, staticRenderFns } from "./AIIcon.vue?vue&type=template&id=6d0aa060&scoped=true"
import script from "./AIIcon.vue?vue&type=script&lang=js"
export * from "./AIIcon.vue?vue&type=script&lang=js"
import style0 from "./AIIcon.vue?vue&type=style&index=0&id=6d0aa060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0aa060",
  null
  
)

export default component.exports